import { Fetch } from '../helpers/fetchWrapper';

const authService = {
  auth_url: process.env.REACT_APP_AUTH_API_URL,
  user_url: process.env.REACT_APP_USER_API_URL,
  task_url: process.env.REACT_APP_LEAD_API_URL,
  /**
   * Hooks
   */

  async health() {
    const res = await Fetch.get(`${this.auth_url}/health`);
    if (res.status >= 200 && res.status < 300) {
      return res;
    }
    const { message } = await res.json();
    throw new Error(message ?? 'Something went wrong');
  },

  async login({ email = '', password = '' }) {
    let res = await Fetch.post(`${this.auth_url}/user-login`, { email, password });
    if (res.status >= 200 && res.status < 300) {
      res = await res.json();
      return res;
    }
    const { message } = await res.json();
    throw new Error(message ?? 'Something went wrong');
  },
  async sendOtp(payload) {
    let res = await Fetch.post(`${this.auth_url}/send-otp`, payload);
    if (res.status >= 200 && res.status < 300) {
      res = await res.json();
      return res;
    }
    const { message } = await res.json();
    throw new Error(message ?? 'Something went wrong');
  },
  async verify(payload) {
    let res = await Fetch.post(`${this.auth_url}/verify-otp`, payload);
    if (res.status >= 200 && res.status < 300) {
      res = await res.json();
      return res;
    }
    const { message } = await res.json();
    throw new Error(message ?? 'Something went wrong');
  },
  async ChangePassword(payload) {
    let res = await Fetch.patch(`${this.auth_url}/change-password`, payload);
    if (res.status >= 200 && res.status < 300) {
      res = await res.json();
      return res;
    }
    const { message } = await res.json();
    throw new Error(message ?? 'Something went wrong');
  },
  async register(payload) {
    let res = await Fetch.post(`${this.auth_url}/register-user`, payload);
    if (res.status >= 200 && res.status < 300) {
      res = await res.json();
      return res;
    }
    const { message } = await res.json();
    throw new Error(message ?? 'Something went wrong');
  },
  async googleLogin(payload) {
    let res = await Fetch.post(`${this.user_url}/google-login`, payload);
    if (res.status >= 200 && res.status < 300) {
      res = await res.json();
      return res;
    }
    const { message } = await res.json();
    throw new Error(message ?? 'Something went wrong');
  },
  async getCurrentAdmin() {
    let res = await Fetch.get(`${this.auth_url}/user-details`);
    if (res.status >= 200 && res.status < 300) {
      res = await res.json();
      return res;
    }
    const { message } = await res.json();
    throw new Error(message ?? 'Something went wrong');
  },
  async updateAdmin(id, values) {
    let res = await Fetch.patch(`${this.auth_url}/update-admin/${id}`, values);
    if (res.status >= 200 && res.status < 300) {
      res = await res.json();
      return res;
    }
    const { message } = await res.json();
    throw new Error(message ?? 'Something went wrong');
  },

  async removeAdminJwt() {
    let res = await Fetch.delete(`${this.auth_url}/logout-user`);
    if (res.status >= 200 && res.status < 300) {
      res = await res.json();
      return res;
    }
    const { message } = await res.json();
    throw new Error(message ?? 'Something went wrong');
  },
  async creatTask(payload) {
    let res = await Fetch.upload(`${this.task_url}/agent/create-task`, 'POST', payload);
    if (res.status >= 200 && res.status < 300) {
      res = await res.json();
      return res;
    }
    const { message } = await res.json();
    throw new Error(message ?? 'Something went wrong');
  },

  async getCrowToken() {

    let res = await Fetch.get(`${this.auth_url}/crow-token`);
    if (res.status >= 200 && res.status < 300) {
      res = await res.json();
      return res;
    }
    const { message } = await res.json();
    throw new Error(message ?? 'Something went wrong');

  },
};
export default authService;
